import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Pagination as AntPagination } from 'antd'
const parentStyle = {
  width: '100%',
  float: 'left',
  height: 'auto',
  marginTop: 10,
}

const containerStyle = { display: 'flex', justifyContent: 'center' }

export class Pagination extends Component {
  shouldComponentUpdate(nextProps) {
    const { page, limit, headers } = this.props

    return (headers && !headers.length) || page !== nextProps.page || limit !== nextProps.limit ||
      (headers && headers['x-pagination-total-count'] &&
        headers['x-pagination-total-count'] !== nextProps.headers['x-pagination-total-count'])
  }

  render() {
    const {
      page,
      limit,
      headers,
      useStyle = true
    } = this.props;

    const total = headers && headers['x-pagination-total-count']
      ? parseInt(headers['x-pagination-total-count'])
      : limit;

    return (
      <div style={useStyle ? parentStyle : {}} >
        <div className={useStyle ? `container` : ''} style={useStyle ? containerStyle : {}} >
          <AntPagination
            current={page}
            pageSize={limit || 20}
            onChange={this.props.handleChangePage}
            total={total}
          />
        </div>
      </div>)
  }
}

const mapStateToProps = (state) => {
  return { ...state }

}

const mapDispatchToProps = {
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Pagination)))